module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/6@2x_56aa4af3f0659d1c61f9ad8781463618.png";